import React from 'react';
import { ClipboardList, HandCoins, Handshake } from 'lucide-react';
import { advantagesData } from '../mock/data';

const iconMap = {
  clipboard: ClipboardList,
  'hand-coins': HandCoins,
  handshake: Handshake
};

const Advantages = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-16 animate-in fade-in slide-in-from-bottom duration-700">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Roulez <span className="text-[#52a675]">l'esprit tranquille</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez les avantages de notre abonnement sur mesure
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {advantagesData.map((advantage, index) => {
            const Icon = iconMap[advantage.icon];
            return (
              <div
                key={advantage.id}
                className="group animate-in fade-in slide-in-from-bottom duration-700"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="text-center space-y-6">
                  {/* Icon Circle */}
                  <div className="inline-flex">
                    <div className="w-24 h-24 bg-gradient-to-br from-[#52a675] to-[#3d8a5c] rounded-full flex items-center justify-center shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                      <Icon className="w-12 h-12 text-white" strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-gray-900">
                      {advantage.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {advantage.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
